import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.includes.js";
import { useLocalization } from '~/composables/_next/useLocalization';
export var PAGES_WITH_NO_SLUG = ['PageProductInformationsListingPage'];
export var getGraphqlPagePrefix = function getGraphqlPagePrefix(contentType, locale) {
  switch (contentType) {
    case 'PageRecipeList':
      return 'recipes';
    case 'PageGenericCategory':
      return 'category';
    case 'PageRecipe':
      return 'recipe';
    case 'PageAdvice':
      return 'page';
    case 'PageAdviceListing':
      return 'pages';
    case 'PageProductInformationsListingPage':
      return '';
    case 'PageProductListingPage':
      return 'products';
    case 'PageBasic':
      return 'content';
    case 'PageAllProduct':
      return '';
    case 'PageProduct':
      return locale === 'fr' ? 'info/fiche-technique' : 'product';
    case 'PageProductInformations':
      return locale === 'fr' ? 'info/fiche-technique' : 'guide';
    default:
      return false;
  }
};
export default function (internalLinkObj) {
  var _internalLinkObj$sys;
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale,
    defaultLocale = _useLocalization.defaultLocale;
  var contentType = internalLinkObj === null || internalLinkObj === void 0 ? void 0 : internalLinkObj.__typename;
  var slug = computed(function () {
    return internalLinkObj === null || internalLinkObj === void 0 ? void 0 : internalLinkObj.slug;
  });
  var internalLinkLocale = (internalLinkObj === null || internalLinkObj === void 0 ? void 0 : (_internalLinkObj$sys = internalLinkObj.sys) === null || _internalLinkObj$sys === void 0 ? void 0 : _internalLinkObj$sys.locale) || locale;
  var internalLink = computed(function () {
    var linkArray = [];
    if (locale !== defaultLocale) {
      linkArray.push(internalLinkLocale);
    }
    var pagePrefix = getGraphqlPagePrefix(contentType, locale);
    if (pagePrefix) {
      linkArray.push(pagePrefix);
    }
    if (!slug.value && !PAGES_WITH_NO_SLUG.includes(contentType)) {
      // page should have a slug, url can't be built
      return null;
    }
    if (slug.value) {
      linkArray.push(slug.value);
    }
    if (linkArray.length > 0) {
      return "/".concat(linkArray.join('/'));
    }
    return null;
  });
  return {
    internalLink: internalLink
  };
}